export const TextInputField: React.FC<{
  label: string;
  labelClassName?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  type?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({
  label,
  labelClassName,
  placeholder,
  value,
  required = false,
  onChange,
  disabled,
  type = "text",
}) => {
  return (
    <div>
      <h2 className={`mb-5 ${labelClassName || "label-light-blue-xl"}`}>
        {label}
        {required && <span className="text-red-500"> *</span>}
      </h2>
      <input
        type={type}
        placeholder={placeholder}
        className={
          disabled ? "form-text-field-border-gray" : "form-text-field-border"
        }
        value={value}
        required={required}
        disabled={disabled}
        onChange={(e) => onChange(e)}
      />
    </div>
  );
};
